module.exports = __webpack_public_path__ + "assets/63a06e11ff79d0590834e0aaf4acde7c.svg";